import { render, staticRenderFns } from "./SocialMediaPlanTitle.vue?vue&type=template&id=bc4c9e36&scoped=true&"
import script from "./SocialMediaPlanTitle.vue?vue&type=script&lang=js&"
export * from "./SocialMediaPlanTitle.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaPlanTitle.vue?vue&type=style&index=0&id=bc4c9e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4c9e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc4c9e36')) {
      api.createRecord('bc4c9e36', component.options)
    } else {
      api.reload('bc4c9e36', component.options)
    }
    module.hot.accept("./SocialMediaPlanTitle.vue?vue&type=template&id=bc4c9e36&scoped=true&", function () {
      api.rerender('bc4c9e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialMediaPlanTitle.vue"
export default component.exports